module.exports = __webpack_public_path__ + "img/lowcode-2-4.ee4c883f.svg";